export default __webpack_public_path__ + "static/media/SashaLovelace.cce6017c.png";